<template>
  <div class="WMap">
    <CallHelpTel />
    <div class="container">
      <div class="title">
        <div class="yellow"></div>
        <div class="article_T">
          <div class="subtitle" :style="{ fontSize: fontSize.h4 + 'em' }">
            隱私保護及安全政策
          </div>
        </div>
      </div>
      <div class="privacy_content">
        <div class="content_wrap">
          <div class="content_title">
            <div class="sec_title" :style="{ fontSize: fontSize.h5 + 'em' }">
              以下為隱私保護及安全政策資訊
            </div>
          </div>
          <div class="content_item">
            <p :style="{ fontSize: fontSize.p + 'em' }">
              歡迎蒞臨勞動部勞動力發展署國人海外就業服務中心網站
              勞動部勞動力發展署（以下簡稱本署）尊重並保護您在使用網際網路時的安全及隱私保護，為了幫助您瞭解「勞動部勞動力發展署國人海外就業服務中心網站」如何保護您在使用本網站各項服務的安全，及如何蒐集、處理與利用您所提供的個人資訊，請您詳細閱讀「勞動部勞動力發展署國人海外就業服務中心網站隱私保護及安全政策」（以下簡稱本政策）。本署同時訂有「勞動部勞動力發展署個人資料保護政策」，以作為本署個人資料管理與隱私保護最高指導方針。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護及安全政策&nbsp;-&nbsp;本政策的適用範圍
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              本政策適用於您在使用「勞動部勞動力發展署全球資訊服務網」各項服務時，所涉及的個人資料蒐集、處理與利用，但不適用於與本網站相互連結之各政府機關網站。凡經由「勞動部勞動力發展署全球資訊服務網」連結之網站，各網站均有其專屬之隱私權政策，「勞動部勞動力發展署全球資訊服務網」不負任何連帶責任。當您連結這些網站時，關於個人資料的保護，適用各該網站的隱私權政策。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                網路安全保護措施&nbsp;-&nbsp;個人資料之蒐集
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              一、單純在「勞動部勞動力發展署全球資訊服務網」瀏覽及檔案下載行為，本網站並不會蒐集任何個人的身份資料。<br />
              二、利用「勞動部勞動力發展署全球資訊服務網」所提供的各項線上申請服務，需申請人提供個人資料時，會依案件辦理需求請您提供姓名、身分證字號、聯絡電話、e-mail、通訊住址及戶籍地址等個人最新、最真實之資料。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;蒐集資料之運用政策
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              「勞動部勞動力發展署全球資訊服務網」會記錄使用者上網的IP位址、上網時間以及在網站內所瀏覽的網頁等資料，這些資料係供本署網站管理單位作網站流量和網路行為調查的總量分析，以利於提昇本網站的服務品質，且僅對全體使用者行為總和進行分析，並不會對個別使用者進行分析。
            </p>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              本網站有義務保護當事人隱私，非經您本人同意不會自行修改或刪除任何個人資料及檔案。除非經過您事先同意或符合以下情況始得為之：
            </p>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              一、違反本網站規定事項，如出現謾罵或做人身攻擊的言論時。<br />
              二、保護或防衛相關個人的權利或所有權。<br />
              三、保護本網站各相關單位之權益。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;與第三方共用個人資料
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              「勞動部勞動力發展署全球資訊服務網」不會任意提供、出售或交換任何您的個人資料給外部單位。但有下列情形者除外：
            </p>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              一、配合司法單位合法的調查。<br />
              二、配合相關職權機關依業務需要之調查或使用。<br />
              三、基於善意相信揭露為法律需要者。<br />
              如符合上述情形，本署會將個人資訊提供給外部單位，請他們根據本署的指示，並遵守本政策和任何其他適當的保密和安全措施，代為處理這類資訊。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;當事人得行使之權利及方式
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              您可透過親臨現場、電話、網路申請等方式行使個人資料保護法第三條當事人權利規定，包含行使個人資料查詢、閱覽、複製本、補充、更正、刪除及停止蒐集、處理與利用之要求。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;用戶資料安全保護政策之諮詢與申訴
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              使用者若對本政策或本署個人資料管理相關事項有任何疑慮，可利用本署電子信箱：wda@wda.gov.tw與本署連絡，或致電本署：(02)89956000（22線），我們將提供完整的說明。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;本署網站cookies運用政策
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              Cookies是伺服端為了區別使用者的不同喜好，經由瀏覽器寫入使用者硬碟的一些簡短資訊。您可以在IE的「Internet選項」的「安全性」中選擇修改您瀏覽器對Cookies的接受程度，包括接受所有的Cookies、設定Cookies時得到通知、拒絕所有Cookies等三種。如果您選擇拒絕所有的Cookies，您就可能無法使用部分個人化服務，或是參與部分的活動。
            </p>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              依據以下目的及情況，本署會在本政策原則之下，在您瀏覽器中寫入並讀取Cookies：<br />
              一、
              為提供更好、更個人化的服務，以及方便您參與個人化的互動活動。Cookies在您註冊或登入時建立，並在您登出時修改。<br />
              二、
              為統計瀏覽人數及分析瀏覽模式，以了解網頁瀏覽的情況，做為改善服務的參考。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;當事人的自我保護
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              請妥善保管您的個人資料，不要隨意將個人資料提供給他人。若您登入本署相關網站服務，請務必記得登出。若您與他人共用電腦，切記要關閉視窗，以防止他人蒐集或使用您的個人資料。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                隱私保護政策&nbsp;-&nbsp;網路安全保護措施
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              任何未經授權而企圖上載或更改本署所提供的各項服務及相關資訊的行為，都是嚴厲禁止而且可能觸犯法律。為了網站安全的目的和確保這項服務能夠繼續服務所有的網路使用者，本網站提供了以下的安全保護措施：<br />

              一、使用網路入侵偵測系統，監控網路流量，以確認未經授權而企圖上載或更改、網頁資訊或蓄意破壞者。<br />
              二、裝設防火牆防止非法入侵、破壞或竊取資料，以避免網站遭到非法使用，以保障使用者的權益。<br />
              三、裝設掃毒軟體，定期掃毒，以提供使用者更安全的網頁瀏覽環境。<br />
              四、執行弱點掃描，並演練發生安全事件時的系統回復程序，並提供適當等級的安全防禦。<br />
              五、每日進行備份作業，將所有資料備份到備援主機。<br />
              六、自動接收所有來自相關作業系統廠商或應用程式廠商所寄發的安全維護電子信通知，並評估電子信的建議，測試、安裝適當的修改程式(PATCH)。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";
import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default {
  components: {
    CallHelpTel,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  display: flex;
  .yellow {
    width: 3%;
    background-color: $main_sec_color;
  }
  .article_T {
    width: 100%;
    background-color: $main_color;
    padding: 20px;
    @include md {
      .subtitle {
        font-size: $p;
      }
    }
    .subtitle {
      color: #fff;
      text-align-last: left;
      margin-bottom: 0;
    }
  }
}
.content_wrap {
  width: 60%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  .content_title {
    margin: 15px 0;
    .sec_title {
      text-align: left;
      font-weight: 600;
    }
  }
  .content_item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 30px;
    .inside_title {
      margin-bottom: 10px;
      border-bottom: 3px dotted $main_color;
    }
    h4 {
      text-align: left;
    }
    P {
      text-align: left;
    }
  }
}
</style>
